import { Component, OnInit, Input } from "@angular/core";

@Component({
    selector: "dodo-whats-next",
    templateUrl: "./whats-next.component.html",
    styleUrls: ["./whats-next.component.scss"],
    standalone: false
})
export class WhatsNextComponent implements OnInit {
	@Input() whatsNext = [];

	constructor() {}

	ngOnInit() {}
}
